import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button, { buttonColors, buttonSizes } from '../../../../components/Button';
import DialogContent from '../../../../components/Dialog/DialogContent';
import { REACT_APP_SANDBOX_FORM_ID } from '../../../../app/config';


const SandboxDialog = () => {
  const [open, setOpen] = useState(false);

  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  const formSrc = "https://docs.google.com/forms/d/e/" +
                  `${REACT_APP_SANDBOX_FORM_ID}` +
                  "/viewform?embedded=true"

  return (
    <>
      <Button
        type="button"
        color={buttonColors.secondary}
        size={buttonSizes.large}
        onClick={openDialog}
        fullWidth
      >
        <span>Request Access to Sandbox</span>
      </Button>
      <Dialog
        open={open}
        onClose={closeDialog}
        maxWidth='md'
        fullWidth
      >
          <DialogContent padding="1.5rem">
            <iframe
              title="Request Access to Sandbox"
              src={formSrc}
              width="900" height="700">
              Loading…
            </iframe>
          </DialogContent>
    </Dialog>
      </>
  );
};

export default SandboxDialog;